import { FormControl, FormLabel } from "@chakra-ui/react";
import React from "react";
import Select from "react-select";

function MySelect({
  label,
  placeholder,
  options,
  onChange = () => {},
  value,
  required,
  multiple = false,
  isHideCross = false,
}) {
  let modifiedOptions, modifiedValue;
  if (options?.[0]?.label) {
    modifiedOptions = options;
  } else {
    modifiedOptions = options?.map((option) => ({
      label: option,
      value: option,
    }));
  }

  if (multiple) {
    // modifiedValue = modifiedOptions.dilter((option)=> option.value === value);
    modifiedValue = modifiedOptions.filter((option) =>
      value?.includes(option.value),
    );
  } else {
    modifiedValue = modifiedOptions.find((option) => option.value === value);
  }
  const isInvalid =
    required && (multiple ? !modifiedValue?.length : !modifiedValue);
  return (
    <FormControl isRequired={required} id={label} isInvalid={isInvalid}>
      <FormLabel htmlFor={label}>{label}</FormLabel>
      <Select
        name={label}
        inputId={label}
        isClearable={isHideCross ? false : true}
        isSearchable
        placeholder={placeholder || label}
        isMulti={multiple}
        value={modifiedValue}
        options={modifiedOptions}
        onChange={(newVal) => {
          onChange(multiple ? newVal.map((v) => v.value) : newVal?.value);
        }}
      />
    </FormControl>
  );
}

export default MySelect;
